import { Expose, Transform, Type } from 'class-transformer';
import {
	calendarDateTransformer,
	integerTransformer,
} from 'src/lib/utilities/api/class-transformer-types';
import {
	UserAddressModel,
	UserAddressModel_ClassTransform_Type,
} from '../../utility/utility-models/address.model';
import {
	ContactFieldMetadata,
	ContactFieldMetadataModel,
	ContactFieldPhoneModel,
	ContactFieldValueModel,
} from '../users/contact-field.model';

// Sub Model Objects
export class StudentInformationPointModel {
	uses_points: boolean;
	total_points: number;
}

export class StudentInformationGraduationPlanModel {
	plan_id: number;
	title: string;
}

export class StudentInformationTrackModel {
	id: number;
	title: string;
}

export class StudentInformationTierModel {
	category: string;
	title: string;
}

export class ContactPrimaryModel extends ContactFieldMetadataModel {}

export class StudentInformationAddressModel extends ContactPrimaryModel {
	@Type(UserAddressModel_ClassTransform_Type)
	value: UserAddressModel;
}

export class AddressPrimaryModel
	extends UserAddressModel
	implements ContactFieldMetadata
{
	prim: boolean;
	active: boolean;
	weight: number;
	type: string;
}

// Main Model Object
export class StudentInformationModel {
	preferred_name?: string;
	attendance_class?: string;
	attendance_class_name: string;
	@Transform(calendarDateTransformer)
	birthdate?: Date;
	first_name?: string;
	middle_name?: string;
	last_name?: string;
	maiden_name?: string;
	pronunciation: string;
	suffix?: string;
	gender?: string;
	race?: string;
	ethnicity?: string;
	grade?: string;
	student_id?: string;
	state_id?: string;
	cohort_year?: string;
	@Transform(integerTransformer)
	courses_concurrent?: number;
	district_id?: string;
	calculated_grade?: number;
	email?: string;
	sr_pay_level?: number;
	district_residence?: string;
	custom_district?: string;
	throttle_status?: string;
	student_location?: string;
	timezone: string;
	institute_timezone: string;

	@Expose({ name: 'more_other' })
	student_memo?: string;

	@Type(StudentInformationTrackModel_ClassTransform_Type)
	track?: StudentInformationTrackModel;

	@Type(StudentInformationGraduationPlanModel_ClassTransform_Type)
	graduation_plan?: StudentInformationGraduationPlanModel;

	@Type(StudentInformationTierModel_ClassTransform_Type)
	tier?: StudentInformationTierModel;

	@Type(StudentInformationEmailModel_ClassTransform_Type)
	contact_emails?: ContactFieldValueModel[];

	@Type(StudentInformationPhoneModel_ClassTransform_Type)
	phone_numbers?: ContactFieldPhoneModel[];

	@Type(UserAddressModel_ClassTransform_Type)
	addresses?: {
		mailing_address: UserAddressModel;
		physical_address: UserAddressModel;
	};

	@Type(StudentInformationPointModel_ClassTransform_Type)
	user_points?: StudentInformationPointModel;
}

export class StudentInformationArgument {
	dob?: Date;
	preferred_name?: string;
	attendance_class?: string;
	attendance_class_name: string;
	birthdate?: Date;
	first_name?: string;
	middle_name?: string;
	last_name?: string;
	maiden_name?: string;
	pronunciation: string;
	suffix?: string;
	gender?: string;
	race?: string;
	grade?: string;
	profile_student_year?: string;
	student_id?: string;
	state_id?: string;
	cohort_year?: string;
	courses_concurrent?: number;
	district_id?: string;
	calculated_grade?: number;
	email?: string;
	sr_pay_level?: number;
	district_residence?: string;
	custom_district?: string;
	throttle_status?: string;
	student_location?: string;
	timezone: string;
	institute_timezone: string;
	student_memo?: string;
	track?: number;
	contact_emails?: ContactFieldValueModel[];
	phone_numbers?: ContactFieldPhoneModel[];
	addresses?: {
		mailing_address?: AddressPrimaryModel;
		physical_address?: AddressPrimaryModel;
	};
	user_points?: StudentInformationPointModel;
	sr_pay_level_notes?: string;
	more_other?: string;
	graduation_plan_id?: number;
}

// TRANSFORMERS
export function StudentInformationPointModel_ClassTransform_Type() {
	return StudentInformationPointModel;
}

export function StudentInformationModel_ClassTransform_Type() {
	return StudentInformationModel;
}

export function StudentInformationAddressModel_ClassTransform_Type() {
	return StudentInformationAddressModel;
}

export function StudentInformationPhoneModel_ClassTransform_Type() {
	return ContactFieldPhoneModel;
}

export function StudentInformationEmailModel_ClassTransform_Type() {
	return ContactFieldValueModel;
}

export function StudentInformationTierModel_ClassTransform_Type() {
	return StudentInformationTierModel;
}

export function StudentInformationGraduationPlanModel_ClassTransform_Type() {
	return StudentInformationGraduationPlanModel;
}

export function StudentInformationTrackModel_ClassTransform_Type() {
	return StudentInformationTrackModel;
}
